import { render, staticRenderFns } from "./MintSel.vue?vue&type=template&id=97efe8a0&scoped=true"
import script from "./MintSel.vue?vue&type=script&lang=js"
export * from "./MintSel.vue?vue&type=script&lang=js"
import style0 from "./MintSel.vue?vue&type=style&index=0&id=97efe8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97efe8a0",
  null
  
)

export default component.exports